import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { api, formatApiError } from '@/lib/api';
import { WrWorkspace } from '@/components/wr/WrWorkspace';

export default function MeWorkforceRecords() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [denied, setDenied] = useState(false);

  const load = async () => {
    try {
      const r = await api.get('/wr/overview');
      setData(r.data);
    } catch (e) {
      if (e?.response?.status === 403) setDenied(true);
      else toast.error(formatApiError(e));
    }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <div className="space-y-6" data-testid="me-wr-page">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{t('wr.title')}</h1>
        <p className="text-base text-muted-foreground mt-1">{t('wr.meSubtitle')}</p>
      </div>
      {denied && <p className="text-base text-muted-foreground" data-testid="me-wr-denied">{t('wr.noAccess')}</p>}
      {data && (
        <WrWorkspace t={t} data={data} canEdit={data.can_edit}
          fetchDetail={(e, r) => api.get(`/wr/records/${e}/${r}`).then((x) => x.data)}
          saveRecord={(e, r, p) => api.put(`/wr/records/${e}/${r}`, p).then((x) => x.data)}
          onSaved={load} />
      )}
    </div>
  );
}
